import config from '../common/config';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { fromJS } from 'immutable';
import { connect } from 'react-redux';
import { Grid, Cell } from 'react-flexr';

import ProductCategory from '../common/product-category';
import { SearchPanel, SearchGroup, Slider } from '../common/search';
import TagFilter from '../common/tagFilter';
import Showcase from '../common/showcase';

function fixValue(value) {
  if(value === undefined || value === null) {
    return '-';
  } else if(value === 0) {
    return 'Ubegrænset';
  }
  return value;
}

const ALL_PRICE = 10000;
const UNLIMITED_DOMAINS = 20;
const UNLIMITED_TRAFFIC = 20;
const UNLIMITED_STORAGE = 20;
@connect(({ webhotel: { offers } }) => ({ offers }))
@withRouter
class Offers extends ProductCategory {
  constructor(props) {
    super(props);

    this.state = this.mapPropsToState(props, {
      offerType: 'webhotel',
      ...this.state,
      defaultFilters: { // FOR FILTERS_USED EPI
        tags: []
      },
      filters: {
        tags: [],
        ...(this.state.filters || {})
      }
    });
  }

  resetFilter() {
    const filters = {
      ...(this.state.filters || {}),
      tags: []
    };
    
    this.setState({
      filters,
      filter: this.createFilter(filters)
    });
  }

  serialiseOffer(offer) {
    const os = (offer.get('operatingSystem') || '').split(',').filter(Boolean);
    const support = (offer.get('supportChannels') || '').split(',').filter(Boolean).map((v) => v.trim() + ' Support');
    const cp = (offer.get('controlPanel') || '').split(',').filter(Boolean).map((v) => v.trim() + ' Controlpanel');

    const tags = [
      offer.get('serverLocation') ? offer.get('serverLocation') : null,
      offer.getIn(['price', 'startup']) === 0 ? 'Gratis oprettelse' : null
    ].concat(offer.get('tags').toJS()).filter(Boolean);
    const manualTags = offer.get('manualTags') ? Array.from(offer.get('manualTags')) : [];
    const mergedTags = tags.reduce((acc, tag) => {
      if(!acc.includes(tag)) {
        acc.push(tag);
      }
      return acc;
    }, manualTags).filter(Boolean);

    for (let index = 0; index < os.length; index++) {
      const tag = os[index];
      if(!mergedTags.includes(tag)) {
        mergedTags.push(tag);
      }
    }

    for (let index = 0; index < support.length; index++) {
      const tag = support[index];
      if(!mergedTags.includes(tag)) {
        mergedTags.push(tag);
      }
    }

    for (let index = 0; index < cp.length; index++) {
      const tag = cp[index];
      if(!mergedTags.includes(tag)) {
        mergedTags.push(tag);
      }
    }

    const result = fromJS({
      id: offer.get('_id'),

      provider: offer.get('provider'),
      product: offer.get('product'),
      logo:
        offer.getIn(['image', 'hash']) &&
        `${config.images}${offer.getIn(['image', 'hash'])}`,
      link: `/redirect/${offer.get('uuid')}`,
      tagline: offer.get('tagline'),
      orderText: 'Bestil her',

      details: [
        {
            value: offer.getIn(['price', 'startup']) === 0 ? 'Gratis' : offer.getIn(['price', 'startup']) || '-', 
            unit: offer.getIn(['price', 'startup']) === 0 ? '' : 'kr.',
            label: 'Oprettelse'
        },
        {
          value: offer.getIn(['price', 'monthlyFirstYear']),
          unit: 'kr./md.',
          label: 'Pris pr. måned første år'
        },
        {
          value: offer.getIn(['price', 'monthlySecondYear']) || '-',
          unit: 'kr./md.',
          label: 'Pris pr. måned i andet år'
        },
        {
          value: fixValue(offer.get('domains')),
          unit: '',
          // size: '1/6',
          label: 'Domæner'
        },
        {
          value: fixValue(offer.get('emails')),
          unit: '',
          // size: '1/6',
          label: 'Emails'
        },
        {
          value: fixValue(offer.get('ftpAccounts')),
          unit: '',
          // size: '1/6',
          label: 'FTP'
        },
        {
          value: fixValue(offer.get('storage')),
          unit: offer.get('storage') > 0 ? 'GB' : '',
          // size: '1/6',
          label: 'Serverplads'
        },
        {
            value: fixValue(offer.get('traffic')),
            unit: '',
            // size: '1/6',
            label: 'Trafik'
        },
        {
          value: fixValue(offer.get('backupPerWeek')),
          unit: '',
          // size: '1/6',
          label: 'Backup pr. uge'
        }
      ].filter(Boolean),

      price: {
        value: offer.getIn(['price', 'totalPriceThreeYear']) || '-',
        unit: 'kr.',
        label: 'Pris i alt for 3 år'
      },

      usps: []
        .concat(mergedTags.map((v) => typeof v === 'string' ? v.trim(): '').filter(Boolean), offer.get('services').toJS())
        .filter(Boolean),

      productDescription: offer.get('productDescription'),
      discountCode: offer.get('discountCode'),
      tags: mergedTags.map((v) => typeof v === 'string' ? v.trim(): '').filter(Boolean),

      _raw: offer
    });

    return result;
  }

  createFilter(filters) {
    this.updateFiltersUsed(filters);
    return offers =>
      offers.filter(offer => {
        const tags = Array.from(offer.get('usps'));
        const services = Array.from(offer.getIn(['_raw', 'services']));
        const filteredTags = filters.tags;
        
        const lowerCaseTags = tags.map(i => i.toLowerCase());
        const lowerCaseServices = services.map(i => i.toLowerCase());
        const lowerCaseProvider = offer.get('provider').toLowerCase().trim().replace('-', ' ');

        for (let idx = 0; idx < filteredTags.length; idx++) {
          const tag = filteredTags[idx];
          if (
            !lowerCaseServices.includes(tag) &&
            !lowerCaseTags.includes(tag) && 
            !tags.includes(tag) &&
            !services.includes(tag) &&
            tag.toLowerCase() !== lowerCaseProvider) {
            return false;
          }
        }

        if(filters.priceThreeYear && offer.getIn(['_raw', 'price', 'totalPriceThreeYear']) > filters.priceThreeYear) {
          return false;
        }

        if(filters.domains && filters.domains !== UNLIMITED_DOMAINS) {
          if(offer.getIn(['_raw', 'domains']) === 0) {
          } else if(offer.getIn(['_raw', 'domains']) > 0 && offer.getIn(['_raw', 'domains']) < filters.domains) {
            return false;
          }
        }

        if(filters.storage && filters.storage !== UNLIMITED_STORAGE) {
          if(offer.getIn(['_raw', 'storage']) === 0) {
          } else if(offer.getIn(['_raw', 'storage']) > 0 && offer.getIn(['_raw', 'storage']) < filters.storage) {
            return false;
          }
        }

        if(filters.traffic && filters.traffic !== UNLIMITED_TRAFFIC) {
          if(offer.getIn(['_raw', 'traffic']) === 0) {
          } else if(offer.getIn(['_raw', 'traffic']) > 0 && offer.getIn(['_raw', 'traffic']) < filters.traffic) {
            return false;
          }
        }

        return true;
      });
  }

  getPrice(value) {
    if (value) {
      const val = parseInt(value[0]);
      if (val == ALL_PRICE || val === 0) {
        return 'Alle';
      }
      return `${val} kr.`;
    }
    return '';
  }

  getDomain(value) {
    if (value) {
      const val = parseInt(value[0]);
      if (val == UNLIMITED_DOMAINS || val === 0) {
        return 'Ubegrænset';
      }
      return `${val}+`;
    }
    return '';
  }

  getStorage(value) {
    if (value) {
      const val = parseInt(value[0]);
      if (val == UNLIMITED_STORAGE || val === 0) {
        return 'Ubegrænset';
      }
      return `${val}+ GB`;
    }
    return '';
  }

  getTraffic(value) {
    if (value) {
      const val = parseInt(value[0]);
      if (val == UNLIMITED_TRAFFIC || val === 0) {
        return 'Ubegrænset';
      }
      return `${val}+`;
    }
    return '';
  }

  render() {
    const { offers, filter, filters, showcases } = this.state;

    return (
      <Grid>
        <Cell size='3/12' portable='1/1'>
          <SearchPanel
            title={'Webhotel'}
            filter={filter}
            results={offers}
            filterTexts={this.createSearchDisplay(filters)}
          >
            <SearchGroup>
              <Slider
                name='priceThreeYear'
                connect='lower'
                disconnected={filters.priceThreeYear === null}
                headline={['Pris i 3 år', this.getPrice]}
                units={['Alle', '10.000 kr. | Alle']}
                min={0}
                max={ALL_PRICE}
                range={{
                  min: [0, 100],
                  '10%': [300, 100],
                  '35%': [1000, 500],
                  '50%': [3000, 1000],
                  max: [ALL_PRICE]
                }}
                defaultStart={[filters.priceThreeYear || ALL_PRICE]}
                onSlide={this.sliderOnChange}
              />
            </SearchGroup>
            <SearchGroup>
              <Slider
                name='domains'
                connect='lower'
                disconnected={filters.domains === null}
                headline={['Domæner', this.getDomain]}
                units={['Ubegrænset', '20+ | Ubegrænset']}
                min={0}
                max={20}
                range={{
                  min: [0, 1],
                  '5%': [1, 1],
                  '50%': [10, 1],
                  max: [UNLIMITED_DOMAINS]
                }}
                defaultStart={[filters.domains || UNLIMITED_DOMAINS]}
                onSlide={this.sliderOnChange}
              />
              <Slider
                name='storage'
                connect='lower'
                disconnected={filters.storage === null}
                headline={['Serverplads', this.getStorage]}
                units={['Ubegrænset', '20+ | Ubegrænset']}
                min={0}
                max={20}
                range={{
                  min: [0, 1],
                  '5%': [1, 1],
                  '50%': [10, 1],
                  max: [UNLIMITED_STORAGE]
                }}
                defaultStart={[filters.storage || UNLIMITED_STORAGE]}
                onSlide={this.sliderOnChange}
              />
              <Slider
                name='traffic'
                connect='lower'
                disconnected={filters.traffic === null}
                headline={['Trafik', this.getTraffic]}
                units={['Ubegrænset', '20+ | Ubegrænset']}
                min={0}
                max={20}
                range={{
                  min: [0, 1],
                  '5%': [1, 1],
                  '50%': [10, 1],
                  max: [UNLIMITED_TRAFFIC]
                }}
                defaultStart={[filters.traffic || UNLIMITED_TRAFFIC]}
                onSlide={this.sliderOnChange}
              />
            </SearchGroup>
            <TagFilter
              headline={'Tags'}
              feed={this.state.feed}
              offerType={this.state.offerType}
              items={offers}
              filters={filters}
              checkboxOnChange={this.tagsOnChange}
            />
          </SearchPanel>
        </Cell>
        <Cell>
          <Showcase list={showcases} orderText='Bestil her' site_id={this.state.siteId} feed={this.state.feed} url={this.state.url} filters_used={this.state.filtersUsed}/>
          {this.renderResults(null, this.resetFilter.bind(this))}
        </Cell>
      </Grid>
    );
  }
}

export default Offers;
